import { bootstrapApiUrl } from '../utils/runtime';

function withNoCache(url, scope = 'full') {
  const rawUrl = url || '/wp-json/pfandpirat/v1/bootstrap';
  const separator = rawUrl.includes('?') ? '&' : '?';
  const params = new URLSearchParams({ _pfp_bootstrap_ts: String(Date.now()) });
  if (scope && scope !== 'full') {
    params.set('scope', scope);
  }
  return `${rawUrl}${separator}${params.toString()}`;
}

export async function loadBootstrapSession({ signal, scope = 'full' } = {}) {
  const response = await fetch(withNoCache(bootstrapApiUrl, scope), {
    method: 'GET',
    credentials: 'include',
    cache: 'no-store',
    signal,
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      'X-WP-Nonce': window?.pfandpiratData?.nonce || '',
    },
  });

  const text = await response.text();
  let payload = null;

  try {
    payload = text ? JSON.parse(text) : null;
  } catch (error) {
    throw new Error('Der Bootstrap-Endpunkt hat keine gültige JSON-Antwort geliefert.');
  }

  if (!response.ok) {
    const message =
      (payload && typeof payload === 'object' && (payload.message || payload.error)) ||
      `Bootstrap fehlgeschlagen: HTTP ${response.status}`;
    const err = new Error(message);
    err.status = response.status;
    err.payload = payload;
    throw err;
  }

  const data = payload?.data && payload?.success === true ? payload.data : payload;
  if (!data || typeof data !== 'object') {
    throw new Error('Der Bootstrap-Endpunkt hat keinen Spielstand geliefert.');
  }

  return data;
}

export function loadDeferredBootstrapSession({ signal } = {}) {
  return loadBootstrapSession({ signal, scope: 'deferred' });
}

export default loadBootstrapSession;
